import uniqueId from '@form-create/utils/lib/unique';
var label = '富文本框';
var name = 'fc-editor';
export default {
  icon: 'icon-editor',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      props: {}
    };
  },
  props: function props() {
    return [{
      type: 'switch',
      field: 'disabled',
      title: '是否禁用'
    }];
  }
};